import FS from 'services/FetchService';

// // Curriculum CourseGroups
// Route::get('/curricula/{curriculum}/groups', 'CurriculumCourseGroupController@getCourseGroups');
// Route::get('/curricula/{curriculum}/groups/{id}', 'CurriculumCourseGroupController@getCourseGroup');
// Route::post('/curricula/{curriculum}/groups', 'CurriculumCourseGroupController@createCourseGroup');
// Route::patch('/curricula/{curriculum}/groups/{id}', 'CurriculumCourseGroupController@updateCourseGroup');
// Route::delete('/curricula/{curriculum}/groups/{id}', 'CurriculumCourseGroupController@deleteCourseGroup');
export default class CurriculumCourseGroupService {
  static async fetch(_, { CurriculumID }) {
    return await FS.get(`/curricula/${CurriculumID}/groups?limit=0`);
  }

  static async get(CurriculumCourseGroupID, { CurriculumID }) {
    return await FS.get(`/curricula/${CurriculumID}/groups/${CurriculumCourseGroupID}`);
  }

  static async save(curriculumGroup, { CurriculumID }) {
    let id = curriculumGroup.CurriculumCourseGroupID;
    let route = `/curricula/${CurriculumID}/groups`;
    let method = id ? 'patch' : 'post';
    if (id) {
      route += `/${id}`;
    }
    return FS[method](route, JSON.stringify(curriculumGroup), {
      header: h => h.append('Content-Type', 'application/json')
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/administration/CurriculumCourseGroupService.js